import { render } from "./QuotationIcon16.vue.js?vue&type=template&id=3c9f2b16!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./QuotationIcon16.vue?vue&type=template&id=3c9f2b16"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__